import { useState, useEffect } from 'react';
import { useForm, Controller } from "react-hook-form";
import { Clock, ChevronDownIcon } from 'lucide-react';
import { RRule } from 'rrule';
import { format } from 'date-fns';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
  DialogClose,
  DialogDescription,
} from '../../@/components/ui/dialog';
import { Button } from '../../@/components/ui/button';
import { Input } from '../../@/components/ui/input';
import { Label } from '../../@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../@/components/ui/select';
import { Textarea } from '../../@/components/ui/textarea';
import { Checkbox } from "../../@/components/ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from '../../@/components/ui/popover';
import axios from 'axios';
import { toast } from "sonner";
import { api_endpoint } from '../constants/constant';
import { useAuth, useUser } from "@clerk/clerk-react";
import { Calendar } from "../../@/components/ui/calendar";
import { ClipLoader } from "react-spinners";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { cn } from "@/lib/utils";
import Papa from "papaparse";
import { EmptyState } from '../components/emptyState';


// Attendees Selection Dialog Component
export default function AttendeesDialog({
  open,
  onOpenChange,
  allUsers,
  allTms,
  selectedAttendees,
  onAttendeesChange
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const dedupedUsers = (() => {
    const map = new Map();
    for (const item of allUsers ?? []) {
      const id = item?.id ?? item?.user_id ?? item?._id;
      if (id == null) continue;
      const key = String(id);
      const existing = map.get(key);
      if (!existing) {
        map.set(key, item);
        continue;
      }
      map.set(key, { ...existing, ...item });
    }
    return Array.from(map.values());
  })();

 const filteredUsers = dedupedUsers.filter((user) => {
    const name = `${user.first_name ?? ""} ${user.last_name ?? ""}`.toLowerCase();
    const email = (user.email ?? "").toLowerCase();
    const term = searchTerm.toLowerCase().trim();
    if (!term) return true;
    return name.includes(term) || email.includes(term);
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg w-[95vw] max-h-[85vh] flex flex-col gap-4">
        <DialogHeader>
          <DialogTitle className="font-heading text-(--neutral-900)">Select Attendees</DialogTitle>
          <DialogDescription className="text-sm text-(--neutral-600) font-body">
            Search and select users to add as attendees.
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 min-h-0 flex flex-col gap-4">
          <div className="space-y-3">
            <Input
              placeholder="Search attendees"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full font-body"
            />
          </div>

          <div className="flex-1 min-h-0 overflow-y-auto space-y-2 pr-1">
            {filteredUsers.length === 0 ? (
              <div className="">
                    {searchTerm.trim()
                      ? `No users found for "${searchTerm.trim()}".`
                      : "No users available."
                    }
              </div>
            ) : (
               filteredUsers.map((user, index) => (
                <div key={`${String(user.id ?? "user")}-${index}`} className="flex items-center gap-2 border-b border-(--neutral-300) py-2">
                  <input
                    type="checkbox"
                    checked={selectedAttendees.includes(user.id)}
                    onChange={() => {
                      if (selectedAttendees.includes(user.id)) {
                        onAttendeesChange(selectedAttendees.filter((id) => id !== user.id));
                      } else {
                        onAttendeesChange([...selectedAttendees, user.id]);
                      }
                    }}
                    className="w-4 h-4"
                  />
                  <span className="font-body ">
                    {user.first_name} {user.last_name} ({user.email})
                  </span>
                </div>
              ))
            )}
          </div>
        </div>

        <DialogFooter className="mt-auto pt-4">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            onClick={() => onOpenChange(false)}
            variant=""
            className=""
            disabled={selectedAttendees.length === 0}
          >
            Add Selected
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}